import React from 'react';
import { Reveal } from './ui/Reveal';
import { SectionHeading } from './SectionHeading';
import { method } from '../data/content';
export function MethodSection() {
  return <section aria-labelledby="metodo" className="border-y border-line bg-canvasAlt" data-id="element-118" data-mp="2u8ql8r3fr07">
      <div className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 py-14 text-center" data-id="element-119" data-mp="3uy18i7u3mxa0">
        <Reveal data-id="element-120" data-mp="3v0dwb1mjg1uz">
          <SectionHeading id="metodo" eyebrow="15 Minutos con la Palabra™" title="El método de 15 minutos" data-id="element-121" data-mp="vimoloi6mnbr" />
        </Reveal>

        <ol className="mx-auto mt-10 grid max-w-5xl gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-122" data-mp="qlw7qyyjznpa">
          {method.map((step, i) => <Reveal key={step.title} as="li" delay={i * 0.04} className="flex h-full flex-col items-center rounded-2xl border border-line bg-surface px-6 py-7 text-center" data-id="element-123" data-mp="hrr9huh3b9zq" data-mpi={i}>
              <span className="rounded-full bg-night px-4 py-1.5 text-xs font-bold uppercase tracking-[0.16em] text-gold-light" data-id="element-124" data-mp="19hvunvcoc120">
                {step.time}
              </span>
              <span className="mt-4 font-display text-2xl font-bold uppercase tracking-wide text-ink" data-id="element-125" data-mp="201ljf3z3ydr2">
                {step.title}
              </span>
              <span className="mt-2 text-sm leading-relaxed text-ink-muted" data-id="element-126" data-mp="1lal8msaw27rr">
                {step.desc}
              </span>
            </Reveal>)}
        </ol>

        <Reveal delay={0.12} data-id="element-127" data-mp="1ca6b8uknh27w">
          <p className="mt-10 font-display text-xl md:text-2xl font-bold uppercase tracking-[0.1em] text-gold" data-id="element-128" data-mp="1ce3vjjiyrztd">
            15 minutos. Una ruta clara.
          </p>
        </Reveal>
      </div>
    </section>;
}